<template>
  <div>
    <Public v-if="this.$route.meta.public === true"></Public>
    <Secure v-if="this.$route.meta.public === false && tokenValid" @logout="logout"></Secure>
  </div>
</template>

<script>
import Secure from '@/views/Secure.vue';
import Public from '@/views/Public.vue';
import EventBus from './utils/event-bus';
import axios from '@/utils/axios-general';

export default {
  name: 'App',
  components: {
    Public,
    Secure
  },
  computed: {

  },
  data () {
    return {
      tokenValid: false,
      publicSection: false
    };
  },
  mounted () {
    // comprobar la url
    if (this.$route.meta.public) {
      // pub
    } else {
      // app
      if (!this.$store.state && !this.$store.state.user && this.$route.path !== '/login') {
        this.$router.replace({ name: 'login' });
      } else {
        this.$i18n.locale = this.$store.state.user.language;
        this.checkLogin();
      }
    }

    EventBus.$on('tokeninvalid', (a) => {
      this.tokenValid = false;
      this.$router.replace({ name: 'login' });
    });

    EventBus.$on('tokenvalid', (a) => {
      this.tokenValid = true;
    });

    EventBus.$on('logout', (a) => {
      this.tokenValid = false;
      this.$store.dispatch('logout');

      if (process.env.NODE_ENV === 'production') {
        window.location.href = '/#main';
      } else {
        window.location.href = 'http://localhost/#main';
      }
    });
  },
  methods: {
    logout () {
      this.$store.dispatch('logout');
      this.$router.replace({ name: 'login' });
    },
    checkLogin: function () {
      axios.defaults.headers.common['x-access-token'] = (this.$store.state.user) ? this.$store.state.user.token : '';
      axios
        .get('renew')
        .then(response => {
          if (response) {
            this.$store.dispatch('storeUser', {
              role: response.data.role,
              login: response.data.login,
              language: response.data.language,
              isExternalLogin: !response.data.isLoginModule
            });
            EventBus.$emit('tokenvalid');
            this.$store.dispatch('renew', response);
          } else {
            EventBus.$emit('tokeninvalid');
          }
        })
        .catch(e => {
          // no hay backend
          this.$router.replace({ name: 'login' });
        });
    }
  }
};
</script>

<style lang="less" src="../static/smart.less"></style>
